module.exports = __webpack_public_path__ + "img/cashbox.87dbdc0a.png";